var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.137,
    height: 24,
    viewBox: "0 0 42.137 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "android",
    transform: "translate(0 -2.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51277",
    "data-name": "Path 51277",
    d: "M21.068,4.109A21.16,21.16,0,0,0,0,23.344H42.137A21.16,21.16,0,0,0,21.068,4.109Zm8.053,11.4a1.758,1.758,0,1,1,1.763,1.752A1.751,1.751,0,0,1,29.122,15.514Zm-17.87,1.752a1.752,1.752,0,1,1,1.764-1.752A1.756,1.756,0,0,1,11.251,17.265Zm0,0",
    transform: "translate(0 3.182)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51278",
    "data-name": "Path 51278",
    d: "M10.413,11.876a.8.8,0,0,1-.364-.094.741.741,0,0,1-.27-.988L14.34,2.882a.726.726,0,0,1,.988-.259.717.717,0,0,1,.27.988l-4.562,7.9A.725.725,0,0,1,10.413,11.876Zm0,0",
    transform: "translate(19.473 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51279",
    "data-name": "Path 51279",
    d: "M7.6,11.876a.725.725,0,0,1-.623-.364l-4.562-7.9a.717.717,0,0,1,.27-.988.726.726,0,0,1,.988.259l4.562,7.912a.73.73,0,0,1-.27.988A.8.8,0,0,1,7.6,11.876Zm0,0",
    transform: "translate(4.653 0)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.57e79cccc8c1c0322bf52988191ffdaf.svg";
export { ForwardRef as ReactComponent };